import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  /* =======================================================
     MOBILE MENU STATE
  ======================================================== */
  mobileMenuOpen: boolean = false;
  
  constructor() {}

  /* =======================================================
     TOGGLE MOBILE MENU
  ======================================================== */
  toggleMobileMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  /* =======================================================
     CLOSE MOBILE MENU:
     This is called whenever a navigation tab is clicked, will automatically close the mobile menu.
  ======================================================== */
  closeMobileMenu(): void {
    this.mobileMenuOpen = false;
  }

  /* =======================================================
     CLOSE WITH ESC KEY
  ======================================================== */
  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closeMobileMenu();
  }

  /* =======================================================
     CLOSE WHEN CLICKING OUTSIDE HEADER
  ======================================================== */
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    /*
      If the click happens outside .site-header,
      close the mobile navigation.
    */
    if (!target.closest('.site-header')) {
      this.closeMobileMenu();
    }
  }

  /* =======================================================
     RESET MENU WHEN RESIZING TO DESKTOP
  ======================================================== */
  @HostListener('window:resize')
  onResize(): void {
    if (window.innerWidth > 1024) {
      this.mobileMenuOpen = false;
    }
  }
}